// extracted by mini-css-extract-plugin
module.exports = {"field-info":"field-info__bMdre"};